import { ReactNode, useCallback, useContext, useEffect } from "react";
import ModalContext from "./ModalContext";

export default function useModal({ onClose }: { onClose?: () => void } = {}) {
  const { setContent, dialogRef } = useContext(ModalContext);

  const showModal = useCallback(
    (content: ReactNode) => {
      setContent(content);
      dialogRef.current?.showModal();
    },
    [setContent, dialogRef],
  );

  const closeModal = useCallback(() => {
    setContent(null);
    dialogRef.current?.close();
  }, [setContent, dialogRef]);

  useEffect(() => {
    return () => closeModal();
  }, [closeModal]);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;

    const handleClose = () => {
      if (onClose) {
        onClose();
      }
    };

    dialog.addEventListener("close", handleClose);

    return () => {
      dialog.removeEventListener("close", handleClose);
    };
  }, [onClose, dialogRef]);

  return {
    showModal,
    closeModal,
  };
}
